<template>
  <div>
    <div class="file message-text__wrap">
      <div class="icon-wrap" :class="{ 'wise-message': isMessageWise }">
        <fluent-icon icon="document" class="file--icon" size="32" />
      </div>
      <div class="meta">
        <h5 class="text-block-title" :class="{ 'wise-message': isMessageWise }">
          {{ decodeURI(fileName) }}
        </h5>
        <a
          class="download clear link button small"
          rel="noreferrer noopener nofollow"
          target="_blank"
          :href="url"
        >
          {{ $t('CONVERSATION.DOWNLOAD') }}
        </a>
      </div>
    </div>
    <div v-if="!!caption" class="message-text__wrap" >
      <div class="text-content">
        {{ caption }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      required: false,
    },
    isMessageWise: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fileName() {
      if (this.url) {
        const filename = this.url.substring(this.url.lastIndexOf('/') + 1);
        return filename || this.$t('CONVERSATION.UNKNOWN_FILE_TYPE');
      }
      return this.$t('CONVERSATION.UNKNOWN_FILE_TYPE');
    },
  },
  methods: {
    openLink() {
      const win = window.open(this.url, '_blank', 'noopener');
      if (win) win.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/variables';

.file {
  display: flex;
  flex-direction: row;
  padding: $space-smaller 0;
  cursor: pointer;

  .icon-wrap {
    font-size: $font-size-giga;
    color: $color-white;
    line-height: 1;
    margin-left: $space-smaller;
    margin-right: $space-slab;
    &.wise-message {
      color: #222 !important;
    }
  }

  .text-block-title {
    margin: 0;
    color: $color-white;
    font-weight: $font-weight-bold;
    word-break: break-word;
    &.wise-message {
      color: #222 !important;
    }
  }

  .button {
    padding: 0;
    margin: 0;
    color: $color-primary-light;
  }

  .meta {
    padding-right: $space-two;
  }

  .time {
    min-width: $space-larger;
  }
}
</style>
